<template>
    <div class="pm50">
        <div class="pd jhnstop row">
            <p class="col">
                <img src="../assets/img/logo.png" class="loginnhjer cz">
            </p>
            <span class="cf fz15" @click="toHome">
                首页
            </span>
        </div>
        <div class="pd mt20">
            <div class=" sdfsdtywer pm20">
                <div class="kkjhnscobox yj4   pr">
                    <span class="diannxjeerr cf fz17">会员卡</span>
                    <p class="fz18 z3 cen mt10">
                        {{memberCard.ticketTypeName}}
                    </p>
                    <p class="cen mt15">
                        <img v-if="!memberCard.isExpired&&memberCard.qrcode" :src="memberCard.qrcode"  class="kmsdst"/>
                    </p>
                    <p class="mt10 z9 fz14 cen">
                        有效期至：{{memberCard.etime}}
                    </p>
                </div>
            </div>
        </div>
        <div class="pd">

        <div class="pd sdfsdtywer mt20 pm15">
            <div class="fz16 z3  row pt10">
                <p class="col">个人资料</p>
                <span class="zts"></span>
            </div>
            <div class="jjnmmnxer mt10 pt10">
                <div class="mt10">
                    <span class="pr f_b">
                        <i class="f_i binknxerrt"></i>
                        <span class="kkmnmxerert">姓 名 </span>
                    </span>
                    <span class="ml10 fz14 z6">{{memberCard.memberName}}</span>
                </div>
                <div class="mt10">
                    <span class="pr f_b">
                        <i class="f_i binknxerrt"></i>
                        <span class="kkmnmxerert">手机号码 </span>
                    </span>
                    <span class="ml10 fz14 z6">{{memberCard.mobile}}</span>
                </div>
                <div class="mt10">
                    <span class="pr f_b">
                        <i class="f_i binknxerrt"></i>
                        <span class="kkmnmxerert">身份证 </span>
                    </span>
                    <span class="ml10 fz14 z6">{{memberCard.idCard}}</span>
                </div>
                <div class="mt10">
                    <span class="pr f_b">
                        <i class="f_i binknxerrt"></i>
                        <span class="kkmnmxerert">学 历 </span>
                    </span>
                    <span class="ml10 fz14 z6">{{memberCard.education}}</span>
                </div>
                <div class="mt10">
                    <span class="pr f_b">
                        <i class="f_i binknxerrt"></i>
                        <span class="kkmnmxerert">性 别 </span>
                    </span>
                    <span class="ml10 fz14 z6">{{memberCard.sex}}</span>
                </div>
            </div>
        </div>
</div>
    </div>
</template>

<script>
import QRCode from "qrcode";
import moment from "moment";
import memberService from "@/services/memberService.js";

export default {
  data() {
    return {
      loading: false,
      memberCard: {
        ticketTypeName: "",
        etime: "",
        qrcode: ""
      }
    };
  },
  methods: {
    toHome() {
      this.$router.push("/");      
    },
    async generateQRCode(text) {
      try {
        return await QRCode.toDataURL(text, {
          width: 200
        });
      } catch (err) {
        this.$toast(err);
      }
    },
    async renew() {
      try {
        this.loading = true;
        let etime = moment()
          .add(this.memberCard.days - 1, "days")
          .format("YYYY-MM-DD");
        await this.$dialog.confirm({ title: "延期至" + etime + "?" });
        let response = await memberService.renewMemberCardAsync(
          this.memberCard.id
        );
        if (response.success) {
          this.$toast("延期成功");
          await this.getMemberCard();
        }
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    async getMemberCard() {
      let memberCard = await memberService.getElectronicMemberCardAsync();
      if (!memberCard.isExpired) {
        memberCard.qrcode = await this.generateQRCode(memberCard.ticketCode);
      }
      this.memberCard = memberCard;
    }
  },
  async created() {
    await this.getMemberCard();
  }
};
</script>

<style scoped>
    .kmsdst {
        width: 140px;
        height: 140px;
    }
    .diannxjeerr{
      top: -30px;
    }
</style>
